// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"524":"9af3c55009427159","700":"92b51a383e52d43d"}[chunkId] + ".js";
};